






























import {
  CarouselImageSettingInfo,
  KeyInfo,
  KeyInfoOptions,
  KeyType,
  KeyTypeOptions,
  ResizeStrategy,
  ResizeStrategyOptions,
} from '@tt4b/ttam-enums';
import { useAllowlist } from '@tt4b/ttam-hooks';
import { PropType, computed, defineComponent, toRefs } from '@vue/composition-api';
import Field from './field/index.vue';

const name = 'ttam-image-settings-enhancements-fields';
export default defineComponent({
  name,
  components: {
    Field,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    carouselImageInfo: {
      type: Object as PropType<CarouselImageSettingInfo>,
      default: () => ({
        keyType: KeyType.Disabled,
        keyInfo: KeyInfo.WithoutKeyInfo,
        resizeStrategy: ResizeStrategy.Original,
      }),
    },
  },
  setup(props, { emit }) {
    const { carouselImageInfo } = toRefs(props);
    const { isVSACarouselOptimizedImagesBackgroudWhite } = useAllowlist();

    const showKeyInfo = computed(() => carouselImageInfo.value.keyType === KeyType.Manual);

    const firstUsableKeyInfo = computed(() => KeyInfoOptions.find(it => !it.disabled)?.value ?? KeyInfo.WithoutKeyInfo);

    const handleKeyTypeChange = (keyType: KeyType) => {
      emit('change', {
        ...carouselImageInfo.value,
        keyType,
        keyInfo: keyType === KeyType.Manual ? firstUsableKeyInfo.value : KeyInfo.WithoutKeyInfo,
      });
    };

    const handleKeyInfoChange = (keyInfo: KeyInfo) => {
      emit('change', {
        ...carouselImageInfo.value,
        keyInfo,
      });
    };

    const handleResizeStrategyChange = (resizeStrategy: ResizeStrategy) => {
      emit('change', {
        ...carouselImageInfo.value,
        resizeStrategy,
      });
    };

    return {
      name,
      showKeyInfo,
      handleKeyTypeChange,
      handleKeyInfoChange,
      handleResizeStrategyChange,
      KeyTypeOptions,
      KeyInfoOptions,
      ResizeStrategyOptions,
      isVSACarouselOptimizedImagesBackgroudWhite,
    };
  },
});
